import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './App.css';
import VideoCanvas from './VideoCanvas';
import VideoStreamComponent from './VideoStreamComponent';
import StreamStatsPanel from './StreamStatsPanel';
  

// const VehicleStats = ({ stats }) => {
//   if (!stats) return null;
  
//   return (
//     <div className="vehicle-stats-overlay">
//       <div className="stat-item in">
//         <span className="stat-label">Vehicles IN:</span>
//         <span className="stat-value">{stats.vehicles_in}</span>
//       </div>
//       <div className="stat-item out">
//         <span className="stat-label">Vehicles OUT:</span>
//         <span className="stat-value">{stats.vehicles_out}</span>
//       </div>
//       <div className="stat-item total">
//         <span className="stat-label">Total:</span>
//         <span className="stat-value">{stats.total_vehicles}</span>
//       </div>
//       <div className="stat-item location">
//         <span className="stat-value">{stats.location}</span>
//       </div>
//     </div>
//   );
// };
const LOCATIONS = {
  'Kuju': [
   
    "KARMA EXIT GATE (CP3103)",
    "KARMA ENTRY GATE (CP3102)",
    "SARUBERA ENTRY GATE (CP3108)",
    "SARUBERA EXIT GATE (CP3109)",
    "KUJU NEW SIDING CHECKPOST ENTRY (CP0921)",
    "TOPA CHECKPOST ENTRY (CP0911)",
    "TOPA CHECKPOST EXIT (CP0912)",
    "KUJU NEW SIDING CHECKPOST EXIT (CP0922)"
  ],

  "Giridih":[
    "GIRIDIH CHECKPOST EXIT (CP1512)",
    "GIRIDIH CHECKPOST ENTRY (CP1511)"
  ],
  "Dhori":[
    "OLD AMLO CHECKPOST EXIT (CP1232)",
    "OLD AMLO CHECKPOST ENTRY (CP1231)",
    "KARIPANI CHECKPOST EXIT (CP1212)",
    "KARIPANI CHECKPOST ENTRY (CP1211)",
    "AMLO CHECKPOST NEW - EXIT (CP1233)",
    "AMLO CHECKPOST NEW - ENTRY (CP1234)"

  ],
  "Kathara":[
    // "GOVINDPUR CHECKPOST ENTRY (CP0531)",
    //   "GOVINDPUR CHECKPOST EXIT (CP0532)",
      "JARANGDIH QUERY CHECKPOST ENTRY (CP0511)",
      "JARANGDIH QUERY CHECKPOST EXIT (CP0512)",
      "JARANGDIH SIDING CHECKPOST EXIT (CP0522)",
      "JARANGDIH SIDING CHECKPOST ENTRY (CP0521)",
      "JRD WB Checkpost 1",
      "Govindpur Checkpost",
      "JRD WB Checkpost 2"

  ],
  "Piparwar":[
    "CHP GATE",
    "Rajdhar Siding CISF CHECK POST",
    "Ashoka Rajdhar Checkpost EXIT (CP1332)",
    "Ashoka Rajdhar Checkpost Entry (CP1331)",
    "Amarpali to CHP CPP checkpost ENTRY (CP1341)",
    "Amarpali to CHP CPP checkpost EXIT (CP1342)",
    "CHP checkpost near road wb12 ENTRY (CP1321)",
    "CHP checkpost near road wb12 EXIT (CP1322)",
    "GOLAMBAR CHECKPOST ENTRY (CP1311)",
    "GOLAMBAR CHECKPOST EXIT (CP1312)"  
  ],
  "NK":[

  ],
  "Rajhara":[

  ],
  "Magadh":[

  ],
  "Barka Sayal":[
    "BURKUNDA EXIT CHECK POST (CP3022)",
    "BURKUNDA ENTRY CHECK POST (CP3021)",
    "Potanga Checkpost (CP0125)",
    "Potanga Checkpost Exit (CP0126)",
    "NEW BIRSA CHECKPOST EXIT (CP0112)",
    "NEW BIRSA CHECKPOST ENTRY (CP0111)",
    "Hesabeda Checkpost Exit (CP0129)",
    "Hesabeda Checkpost Entry (CP0128)",
    "NEW SAYAL D CHECKPOST ENTRY (CP0123)"
  ],
  "Argada":[
    "Giddi A EXIT GATE (CP3052)",
    "Giddi A ENTRY GATE (CP3051)",
    "SIRKA ENTRY GATE (CP3005)",
    "SIRKA EXIT GATE (CP3006)",
    "Giddi C ENTRY GATE (CP3053)",
    "Giddi C EXIT GATE (CP3054)",
    "OCP Checkpost No. 2+Dumper Yard",
    "Checkpost - GiddiA",
    "New Checkpost Religara",
    "Giddi C Checkpost"
  ],
  "Hazaribagh":[
    "KEDLA WASHERY CHECKPOST ENTRY (CP1022)",
    "Tapin North Checkpost Entry (CP1004)",
    "Tapin North Checkpost Entry (CP1003)",
    "Tapin south checkpost EXIT (CP1002)"

  ],
  "Rajrappa":[ 
    "Rajrappa ENTRY Gate (CP1101)",
    "Rajrappa EXIT Gate (CP1102)",
  ],
  "B&K":[
    "BOKARO OC CHECKPOST EXIT (CP0422)",
    "BOKARO OC CHECKPOST ENTRY (CP0421)",
    "KARO CHECKPOST EXIT (CP0412)",
    "KARO CHECKPOST ENTRY (CP0411",
    "kmp CCL Checkpost"


  ],
  "Amrapali":[

  ]
};
const LOCATION_CAMERA_IPS = {
  
//GIRIDIH
    "GIRIDIH CHECKPOST EXIT (CP1512)":[
      
            "172.24.190.61",
            "172.24.190.62"
    ],
      "GIRIDIH CHECKPOST ENTRY (CP1511 )":[
        "172.24.190.55",
        "172.24.190.56"
      ],
        "SARUBERA ENTRY GATE (CP3108)":[
        "172.24.198.54",
        "172.24.198.55"
        ],
        "SARUBERA EXIT GATE (CP3109)":[
        "172.24.198.60",
        "172.24.198.61"
        ],

        "KARMA ENTRY GATE (CP3102)":[
          "172.24.198.70",
          "172.24.198.71"
        ],
        "KARMA EXIT GATE (CP3103)":[
          "172.24.198.72",
          "172.24.198.73"
        ],

        "TOPA CHECKPOST ENTRY (CP0911)" :[
        "172.24.185.26",
        "172.24.185.27",
        ],
        "TOPA CHECKPOST EXIT (CP0912)" :[
        "172.24.185.28",
        "172.24.185.29"
        ],
        "KUJU NEW SIDING CHECKPOST ENTRY (CP0921)" :[
        "172.24.185.10",
        "172.24.185.11"
        ],
        "KUJU NEW SIDING CHECKPOST EXIT (CP0922)":[
        "172.24.185.12",
        "172.24.185.13"
        ],
        "OLD AMLO CHECKPOST EXIT (CP1232)":[
      "172.24.203.22",
      ],
      "OLD AMLO CHECKPOST ENTRY (CP1231)":[
      "172.24.203.27"
      ],
      "KARIPANI CHECKPOST EXIT (CP1212)":[
      "172.24.203.155",
      "172.24.203.156"
      ],
      "KARIPANI CHECKPOST ENTRY (CP1211)":[
      "172.24.203.146",
      "172.24.203.147"
      ],
      "AMLO CHECKPOST NEW - EXIT (CP1233)":[
      "172.24.203.125",
      "172.24.203.126"
      ],
      "AMLO CHECKPOST NEW - ENTRY (CP1234)":[
      "172.24.203.114",
      "172.24.203.119"
      ],
      "GOVINDPUR CHECKPOST ENTRY (CP0531)":[
"172.24.185.42",
"172.24.185.43"
],
"GOVINDPUR CHECKPOST EXIT (CP0532)":[
"172.24.185.44",
"172.24.185.45"
],
"JARANGDIH QUERY CHECKPOST ENTRY (CP0511)":[
"172.24.201.202",
"172.24.201.203"
],
"JARANGDIH QUERY CHECKPOST EXIT (CP0512)":[
"172.24.201.204",
"172.24.201.205"

],
"JARANGDIH SIDING CHECKPOST EXIT (CP0522)":[
"172.24.201.219",
"172.24.201.220"
],
"JARANGDIH SIDING CHECKPOST ENTRY (CP0521)":[
"172.24.201.221",
"172.24.201.222"
],
"JRD WB Checkpost 1":[
"172.25.2.15",
"172.25.2.16"
],
"Govindpur Checkpost":[
"172.25.3.7"
],
"JRD WB Checkpost 2":[
"172.25.2.17"
],
"CHP GATE":[
"170.20.13.156"
],
"Rajdhar Siding CISF CHECK POST":[
"170.20.13.199"
],
"Ashoka Rajdhar Checkpost EXIT (CP1332)":[
"172.24.190.134",
"172.24.190.135"
],
"Ashoka Rajdhar Checkpost Entry (CP1331)":[
"172.24.190.140",
"172.24.190.141"
],
"Amarpali to CHP CPP checkpost ENTRY (CP1341)":[
"172.24.190.150",
"172.24.190.151"
],
"Amarpali to CHP CPP checkpost EXIT (CP1342)":[
"172.24.190.156",
"172.24.190.157"
],
"CHP checkpost near road wb12 ENTRY (CP1321)":[
"172.24.190.166",
"172.24.190.167"
],
"CHP checkpost near road wb12 EXIT (CP1322)":[
"172.24.190.173",
"172.24.190.174"
],
"GOLAMBAR CHECKPOST ENTRY (CP1311)":[
"172.24.190.182",
"172.24.190.183"
],
"GOLAMBAR CHECKPOST EXIT (CP1312)":[
"172.24.190.188",
"172.24.190.189"
],

"BURKUNDA EXIT CHECK POST (CP3022)":[
"172.24.196.235",
"172.24.196.236"
],
"BURKUNDA ENTRY CHECK POST (CP3021)":[
"172.24.196.237",
"172.24.196.238"
],
"Potanga Checkpost (CP0125)":[
"172.24.190.219",
"172.24.190.220"
],
"Potanga Checkpost Exit (CP0126)":[
"172.24.190.221",
"172.24.190.222"
],
"NEW BIRSA CHECKPOST EXIT (CP0112)":[
"172.24.190.235",
"172.24.190.236"
],
"NEW BIRSA CHECKPOST ENTRY (CP0111)":[
"172.24.190.237",
"172.24.190.238"
],
"Hesabeda Checkpost Exit (CP0129)":[
"172.24.190.202",
"172.24.190.203"
],
"Hesabeda Checkpost Entry (CP0128)":[
"172.24.190.204",
"172.24.190.205"
],
"NEW SAYAL D CHECKPOST ENTRY (CP0123)":[
"172.24.189.150",
"172.24.189.151"
],
"NEW SAYAL D CHECKPOST EXIT (CP0124)":[
"172.124.189.156",
"172.124.189.157"
],


"Giddi A EXIT GATE (CP3052)":[
"172.24.199.91",
"172.24.199.92"
],
"Giddi A ENTRY GATE (CP3051)":[
"172.24.199.93",
"172.24.199.94"
],
"SIRKA ENTRY GATE (CP3005)":[
"172.24.199.75",
"172.24.199.76"
],
"SIRKA EXIT GATE (CP3006)":[
"172.24.199.77",
"172.24.199.78"
],
"Giddi C ENTRY GATE (CP3053)":[
"172.24.199.102"
],
"Giddi C EXIT GATE (CP3054)":[
"172.24.199.104",
"172.24.199.105"
],
"OCP Checkpost No. 2+Dumper Yard":[
"172.18.0.37",
"172.18.0.38",
"172.18.0.39",
"172.18.0.40"
],
"Checkpost - GiddiA":[
"172.18.0.86",
"172.18.0.87"
],
"New Checkpost Religara":[
"172.18.0.122",
"172.18.0.123",
"172.18.0.124",
],
"Giddi C Checkpost":[
"172.18.0.168",
"172.18.0.169"
],


"KEDLA WASHERY CHECKPOST ENTRY (CP1022)":[
"172.24.129.122",
"172.24.129.123",
"172.24.129.124",
"172.24.129.125"
],
"Tapin North Checkpost Entry (CP1004)":[
"172.24.129.155",
"172.24.129.156"
],
"Tapin North Checkpost Entry (CP1003)":[
"172.24.129.157",
"172.24.129.158"
],
"Tapin south checkpost EXIT (CP1002)":[
"172.24.150.250",
"172.24.150.251"
],


    "Rajrappa ENTRY Gate (CP1101)":[
    "172.24.200.37",
    "172.24.200.38",
    ],

    "Rajrappa EXIT Gate (CP1102)":[
    "172.24.200.39",
    "172.24.200.40"
    ],


    "BOKARO OC CHECKPOST EXIT (CP0422)":[
      "172.24.50.122",
      "172.24.50.123"
    ],
    "BOKARO OC CHECKPOST ENTRY (CP0421)":[
      "172.24.50.242",
      "172.24.50.243"
    ],
    "KARO CHECKPOST EXIT (CP0412)":[
      "172.24.49.49",
      "172.24.49.50"
    ],
    "KARO CHECKPOST ENTRY (CP0411":[
      "172.24.49.51",
      "172.24.49.52"
    ],
    "kmp CCL Checkpost":[
      "172.24.85.63"
    ]














};
const CAMERA_NAMES = {
  
   
   "172.24.198.86":"CAM 1",
    "172.24.198.87":"CAM 2",
    "172.24.198.70":"CAM 3",
    "172.24.198.71":"CAM 4",
    "172.24.198.72":"CAM 5",
    "172.24.198.73":"CAM 6",
   " 172.24.185.26":"CAM 10",
"172.24.185.27":"CAM 7",
"172.24.185.28":"CAM 8",
"172.24.185.29":"CAM 9"



   

  
};
const BASE_URL = {
  "Kuju": "https://kuju.cclai.in/ee",
  "Giridih":"https://giridih.cclai.in/ee",
  "Dhori":"https://dhori.cclai.in/ee",
  "Kathara":"https://kathara.cclai.in/ee",
  "Piparwar":"https://piparwar.cclai.in/ee",
  "NK":"https://nk.cclai.in/ee",
  "Rajhara":"https://rajhara.cclai.in/ee",
  "Magadh":"https://magadh.cclai.in/ee",
  "Barka Sayal":"https://barkasayal.cclai.in/ee",
  "Argada":"https://argada.cclai.in/ee",
  "Hazaribagh":"https://hazaribagh.cclai.in/ee",
  "Rajrappa":"https://rajrappa.cclai.in/ee",
  "B&K":"https://bk.cclai.in/ee",
  "Amrapali":"https://amrapali.cclai.in/ee"

};

function ReportFilterModal({}) {
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedCamera, setSelectedCamera] = useState('');
  const [availableLocations, setAvailableLocations] = useState([]);
  const [availableCameras, setAvailableCameras] = useState([]);
  const [isStreaming, setIsStreaming] = useState(false);
  const [streamUrl, setStreamUrl] = useState('');
  const [streamStats, setStreamStats] = useState(null);
  const statsTimerRef = useRef(null);

  useEffect(() => {
    if (selectedArea) {
      setAvailableLocations(LOCATIONS[selectedArea] || []);
      setSelectedLocation('');
      setSelectedCamera('');
      setAvailableCameras([]);
    }
  }, [selectedArea]);

  useEffect(() => {
    if (selectedLocation) {
      const cameraIps = LOCATION_CAMERA_IPS[selectedLocation] || [];
      setAvailableCameras(cameraIps);
      setSelectedCamera('');
    }
  }, [selectedLocation]);

  useEffect(() => {
    return () => {
      if (statsTimerRef.current) {
        clearInterval(statsTimerRef.current);
      }
      stopStream();
    };
  }, []);

  useEffect(() => {
    const fetchStats = async () => {
      if (!selectedCamera || !selectedArea) return;
      const baseUrl = BASE_URL[selectedArea];
      try {
        const statsResponse = await axios.get(`${baseUrl}/stream-stats/${selectedCamera}`);
        setStreamStats(statsResponse.data);
      } catch (error) {
        console.error("Error fetching stream stats:", error);
      }
    };
    fetchStats();
  }, [selectedCamera]);

  const handleAreaChange = (e) => {
    stopStream();
    setSelectedArea(e.target.value);
  };

  const handleLocationChange = (e) => {
    stopStream();
    setSelectedLocation(e.target.value);
  };

  const handleCameraChange = (e) => {
    stopStream();
    setSelectedCamera(e.target.value);
  };

  const startStream = async () => {
    if (!selectedCamera || !selectedArea) return;

    try {
      const baseUrl = BASE_URL[selectedArea];
      if (!baseUrl) {
        alert("Invalid area selected. Please try again.");
        return;
      }

      const response = await axios.post(`${baseUrl}/start-stream`, {
        camera_ip: selectedCamera
      });
      setStreamUrl(`${baseUrl}${response.data.stream_url}`);
      setIsStreaming(true);

      statsTimerRef.current = setInterval(async () => {
        try {
          const statsResponse = await axios.get(`${baseUrl}/stream-stats/${selectedCamera}`);
          setStreamStats(statsResponse.data);
        } catch (error) {
          console.error("Error fetching stream stats:", error);
        }
      }, 10000);
    } catch (error) {
      console.error("Error starting stream:", error);
      alert("Failed to start stream. Please try again.");
    }
  };

  const stopStream = async () => {
    if (!isStreaming) return;

    try {
      const baseUrl = BASE_URL[selectedArea];
      if (!baseUrl) {
        alert("Invalid area selected. Please try again.");
        return;
      }
      const response = await axios.post(`${baseUrl}/stop-stream`, {
        camera_ip: selectedCamera
      });
      console.log("Stream stopped:", response.data);
    } catch (error) {
      console.error("Error stopping stream:", error);
      alert("Failed to stop stream. Please try again.");
    } finally {
      setIsStreaming(false);
      setStreamUrl('');
      setStreamStats(null);
      if (statsTimerRef.current) {
        clearInterval(statsTimerRef.current);
      }
    }
  };

  return (
    <div className="App">
      <div className="controls-container">
        <div className="dropdown-container">
          <div className="dropdown-group" style={{ display: 'flex', gap: '22rem', alignItems: 'center' }}>
            <div className="dropdown-item" style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="area-select" style={{ position: 'absolute', top: '-0.1rem', color: 'white' }}>Area:</label>
              <select id="area-select" className='area-select' value={selectedArea} onChange={handleAreaChange} disabled={isStreaming}>
                <option value="">Select Area</option>
                {Object.keys(BASE_URL).map(area => (
                  <option key={area} value={area}>{area}</option>
                ))}
              </select>
            </div>

            <div className="dropdown-item" style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="location-select" style={{ position: 'absolute', top: '-0.1rem', color: 'white' }}>Location:</label>
              <select id="location-select" className='location-select' value={selectedLocation} onChange={handleLocationChange} disabled={!selectedArea || isStreaming}>
                <option value="">Select Location</option>
                {availableLocations.map(location => (
                  <option key={location} value={location}>{location}</option>
                ))}
              </select>
            </div>

            <div className="dropdown-item" style={{ display: 'flex', flexDirection: 'column' }}>
              <label htmlFor="camera-select" style={{ position: 'absolute', top: '-0.1rem', color: 'white' }}>Camera:</label>
              <select id="camera-select" className='camera-select' value={selectedCamera} onChange={handleCameraChange} disabled={!selectedLocation || isStreaming}>
                <option value="">Select Camera</option>
                {availableCameras.map(ip => (
                  <option key={ip} value={ip}>{CAMERA_NAMES[ip] || 'Camera'} ({ip})</option>
                ))}
              </select>
            </div>

            <div className="stream-controls">
              {!isStreaming ? (
                <button className="start-btn" onClick={startStream} disabled={!selectedCamera}>Start Stream</button>
              ) : (
                <button className="stop-btn" onClick={stopStream}>Stop Stream</button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="stream-container" style={{ width: '70%', height: '70%', margin: 'auto' }}>
        {isStreaming ? (
          <div className="video-container" style={{ width: '100%', height: '100%', maxHeight: '400px' }}>
            <VideoStreamComponent streamUrl={streamUrl} />
          </div>
        ) : (
          <div className="stream-placeholder" style={{ width: '100%', height: '300px' }}>
            <div className="placeholder-text">
              Select a camera and click "Start Stream" to begin monitoring
            </div>
          </div>
        )}
      </div>

      <StreamStatsPanel stats={streamStats} />
    </div>
  );
}

export default ReportFilterModal;
